module.exports = {
          srcSet: __webpack_public_path__ + "53d5fdaabd1d937cd91a0d1ac2810d57-167.png"+" 167w",
          images:[ {path: __webpack_public_path__ + "53d5fdaabd1d937cd91a0d1ac2810d57-167.png",width: 167,height: 167}],
          src: __webpack_public_path__ + "53d5fdaabd1d937cd91a0d1ac2810d57-167.png",
          toString:function(){return __webpack_public_path__ + "53d5fdaabd1d937cd91a0d1ac2810d57-167.png"},
          
          width: 167,
          height: 167
        }